import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import { Invoice } from "../../interfaces/screens/billing";
import StatusChip from "../../components/statusChip";
import {
  mapInvoiceStatusToChipStatus,
  mapInvoiceStatusToText,
} from "../utils/helper";
import CurrencyDisplay from "../../components/currencyDisplay";
import { FilePlus2, Edit, FileDown } from "lucide-react";

interface InvoiceColumnHandlers {
  onEdit: (invoice: Invoice) => void;
  onGenerateClaim: (invoice: Invoice) => void;
  onExport: (invoice: Invoice) => void;
}

export const getInvoicesTableColumns = (
  handlers: InvoiceColumnHandlers,
): TableColumnsItem[] => [
  { key: "invoice_number", name: "Invoice #", type: ColumnType.TEXT },
  { key: "patient_name", name: "Patient", type: ColumnType.TEXT },
  { key: "issue_date", name: "Issue Date", type: ColumnType.TEXT },
  { key: "due_date", name: "Due Date", type: ColumnType.TEXT },
  {
    key: "status",
    name: "Status",
    type: ColumnType.CUSTOM,
    customValue: (row: Invoice) => (
      <StatusChip
        status={mapInvoiceStatusToChipStatus(row.status)}
        label={mapInvoiceStatusToText(row.status)}
      />
    ),
  },
  {
    key: "total_amount",
    name: "Total",
    type: ColumnType.CUSTOM,
    customValue: (row: Invoice) => {
      const total = row.line_items.reduce(
        (acc, item) => acc + item.unit_price * item.quantity,
        0,
      );
      const currency =
        row.line_items.length > 0 ? row.line_items[0].currency : "USD";
      return <CurrencyDisplay amount={total} currency={currency} />;
    },
  },
  {
    key: "actions",
    name: "",
    type: ColumnType.BUTTON,
    buttonsList: [
      {
        type: ButtonType.ICON,
        icon: Edit,
        onPress: (e: React.MouseEvent, row: Invoice) => handlers.onEdit(row),
      },
      {
        type: ButtonType.ICON,
        icon: FilePlus2,
        onPress: (e: React.MouseEvent, row: Invoice) =>
          handlers.onGenerateClaim(row),
      },
      {
        type: ButtonType.ICON,
        icon: FileDown,
        onPress: (e: React.MouseEvent, row: Invoice) => handlers.onExport(row),
      },
    ],
  },
];
